export class AssetComponentAdd {
    assetComponentIds: number[];
    employeeId: number;
}
